import { type CompanyConfig, TimeFormat } from '../interface';

export const ElectroniumConfig: CompanyConfig = {
  id: '11f1cb17-bea9-477a-b921-5a0fd7e7fa36',
  lang: 'en',
  langs: ['en'],
  name: 'Electronium DEMO',
  nameSecondary: 'ElectroniumDEMO',
  currency: '£',
  currencyCode: 'GBP',
  officialName: 'Electronium DEMO',
  email: 'support@jiffygrocery.co.uk',
  feedbackEmail: 'support@jiffygrocery.co.uk',
  marketingEmail: 'support@jiffygrocery.co.uk',
  phonePlaceholder: '+44',
  defaultPhoneCode: '+44',
  phoneNumber: '+44 00 0 000 0000',
  ageRestricted: 21,
  timeZone: 'Europe/London',
  minimalOrderFeeThreshold: 700,
  address:
    '25 Saint Bride Street, Farringdon Within, Blackfriars, City of London, London, England, GBR',
  canonical: '',
  defaultVolumeDisplay: '1x',
  warehouse: {
    default: 'PARWH',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 48.852735,
      lng: 2.350793,
    },
  },
  map: {
    center: { lat: 48.852735, lng: 2.350793 },
    zoom: 12,
  },
  paymentMethods: ['cash', 'gpay', 'applepay', 'visa', 'mc'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    whatsapp: 'https://wa.me/+440000000000',
    facebook: 'https://www.facebook.com/',
    instagram: 'https://www.instagram.com/',
    tiktok: '',
    youtube: '',
    linkedin: 'https://www.linkedin.com/',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    blog: '',
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
  },
  appStoreUrl: {
    ios: 'https://apps.apple.com',
    android: 'https://play.google.com',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  apis: {},
  countryCode: 'GB',
  license: {
    name: 'Cloud Retail LTD',
    numberPrinary: 'License Number',
    numberSecondary: '',
  },
};
